import {RootState} from '../reducer/index'
import {Criteria, OrderByType} from '../../../type/criteria/criteria'
import {IPagination} from '../../../type/paginated'
import {IPaginateState} from '../reducer/generic/paginateReducer'
import {_API} from './_Action'

export const _PAGINATE = (name: string) => ({
  INIT: `PAGINATE_${name}_INIT`,
  NEXT_PAGE: `PAGINATE_${name}_NEXT_PAGE`,
  PREV_PAGE: `PAGINATE_${name}_PREV_PAGE`,
  GO_TO_PAGE: `PAGINATE_${name}_GO_TO_PAGE`,
  LOAD_MORE: `PAGINATE_${name}_LOAD_MORE`,
  FETCH_MORE_REQUEST: `PAGINATE_${name}_FETCH_MORE_REQUEST`,
  FETCH_MORE_SUCCESS: `PAGINATE_${name}_FETCH_MORE_SUCCESS`,
  FETCH_MORE_FAILURE: `PAGINATE_${name}_FETCH_MORE_FAILURE`,
  RESET_CRITERIA: `PAGINATE_${name}_RESET_CRITERIA`,
  RESET_CRITERIA_BY_OBJECT: `PAGINATE_${name}_RESET_CRITERIA_BY_OBJECT`,
  UPDATE_CRITERIA: `PAGINATE_${name}_UPDATE_CRITERIA`,
  UPDATE_OBJECT_CRITERIA: `PAGINATE_${name}_UPDATE_OBJECT_CRITERIA`,
  UPDATE_FILTER_OBJECT_CRITERIA: `PAGINATE_${name}_UPDATE_FILTER_OBJECT_CRITERIA`,
  SORT: `PAGINATE_${name}_SORT`,
  ..._API(`PAGINATE_${name}`)
})

export class PaginateAction<T> {

  constructor(private name: string, private action: (c?: Criteria) => (dispatch, getState: () => RootState) => Promise<IPagination<T>>) {

  }

  nextPage = () => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).NEXT_PAGE})
    return this.fetch(dispatch, getState)
  }

  prevPage = () => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).PREV_PAGE})
    return this.fetch(dispatch, getState)
  }

  goToPage = (pageNumber: number) => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).GO_TO_PAGE, pageNumber})
    return this.fetch(dispatch, getState)
  }

  sort = (sortBy: string, orderBy: OrderByType) => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).SORT, sortBy, orderBy})
    return this.fetch(dispatch, getState)
  }

  updateCriteria = (name: string, value: any) => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).UPDATE_CRITERIA, name, value})
    return this.fetch(dispatch, getState)
  }

  updateCriteriaByObject = (object: any)  => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).UPDATE_OBJECT_CRITERIA, object})
    return this.fetch(dispatch, getState)
  }

  resetCriteria = ()  => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).RESET_CRITERIA})
    return this.fetch(dispatch, getState)
  }

  resetCriteriaByObject = (object: any)  => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).RESET_CRITERIA_BY_OBJECT, object})
    return this.fetch(dispatch, getState)
  }

  updateFilterCriteriaByObject = (object: any)  => (dispatch, getState: () => RootState) => {
    dispatch({type: _PAGINATE(this.name).UPDATE_FILTER_OBJECT_CRITERIA, object})
    return this.fetch(dispatch, getState)
  }
  

  private fetch(dispatch, getState: () => RootState) {
    return this.action(this.getState(getState).criteria)(dispatch, getState)
  }

  private getState(getState: () => RootState): IPaginateState<T> {
    return getState().paginate[this.name] as IPaginateState<T>
  }
}



// WEBPACK FOOTER //
// ./src/core/redux/action/paginateAction.ts